var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('a-pagination',{attrs:{"total":_vm.total,"itemRender":_vm.itemRender,"current":_vm.current,"pageSize":_vm.pageSize},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }